"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = useClearOnTime;
var react_1 = require("react");
function useClearOnTime(_a) {
    var setText = _a.setText, text = _a.text;
    (0, react_1.useEffect)(function () {
        if (text) {
            // Запускаем таймер только если текст существует
            var timer_1 = setTimeout(function () {
                setText(""); // очищаем текст
            }, 3000);
            // Очищаем таймер при размонтировании или изменении текста
            return function () {
                clearTimeout(timer_1);
            };
        }
    }, [text, setText]); // Зависимость теперь от текста и setText
    return null;
}
